<!-- Modal -->
<template>
    <div class="modal fade" id="subscriberNotificationsLogModalModal" ref="subscriberNotificationsLogModalModal" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                
                <div class="modal-header align-items-start">
                    <div>
                        <h5 class="modal-title" id="createLabel">Subscriber Notifications Log</h5>
                        <small>{{ subscriber && subscriber.name }}</small>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="table-responsive">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col">Type</th>
                                            <th scope="col">Provider</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Created</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="subscriberStatuses.length">
                                        <tr v-for="status in subscriberStatuses" :key="status.id" :class="(status.status.startsWith('undelivered') || (!status.status.startsWith('Successfully') && status.type == 'email')) ? 'table-danger' : ''">
                                            <td>{{ status.type }}</td>
                                            <td>{{ status.provider }}</td>
                                            <td v-html="status.status"></td>
                                            <td>{{ momentTz(status.created_at, 'UTC').tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('YYYY-MM-DD HH:mm:ss') }}</td>
                                            <!-- <td>{{ moment(status.created_at).format('YYYY-MM-DD HH:mm:ss') }}</td> -->
                                            <!-- // Convert server time to user's local time
    this.userTime = this.$momentTz(this.serverTime, serverTimezone).tz(userTimezone).format('YYYY-MM-DD HH:mm:ss'); -->
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="4" class="text-center">No data found</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <Pagination :totalItems="totalRows" :currentPage="page" :perPage="perPage" @pageChanged="setPage" :goButton="false" styled="simple" borderActiveColor="" borderTextActiveColor="text-white" :float-right="true" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { Modal } from "bootstrap";
import restApi from '@/api/index.js'
import Pagination from "@/components/juniper/pagination/Pagination";

export default {
    name: "SubscriberNotificationsLogModal",
    components: {
        Pagination
    },
    emits: [],
    data: () => ({
        modal: null,
        subscriber: null,
        subscriberStatuses: [],
        inProgress: false,
        page: 1,
        totalRows: 0,
        perPage: 10,
        filters: [],
    }),
    mounted() {
        this.modal = new Modal(this.$refs.subscriberNotificationsLogModalModal);

        let subscriberNotificationsLogModalModal = document.getElementById("subscriberNotificationsLogModalModal");

        let self = this;
        
        subscriberNotificationsLogModalModal.addEventListener("hidden.bs.modal", function () {
            self
            
        });
    },
    watch: {
        page: function () {
            this.getSubscriberStatuses();
        },
    },
    methods: {
        showModal: async function (value, subscriber) {
            if (value) {
                this.modal.show();
                this.subscriber = subscriber;
                this.getSubscriberStatuses();
            }
        },
        getSubscriberStatuses: async function () {
            this.inProgress = true;
            try {
                let { hostname } = new URL(this.subscriber.website);
                let subscriberWpId = this.subscriber.wordpress_id;
                // for testing purposes
                if (hostname === 'localhost') {
                    hostname = 'www.wiltonnd.org';
                    subscriberWpId = 2468;
                }
                let res = await restApi.get(`/tw/subscribers/${hostname}/${subscriberWpId}/status-logs?limit=${this.perPage}&filters=${this.filters}&page=${this.page}`, {});
                
                this.subscriberStatuses = res.data.data;
                this.totalRows = res.data.total;
            } catch (error) {
                console.log(error);
            } finally {
                this.inProgress = false;
            }
        },
        setPage(n) {
            this.page = n;
        },
    },
    computed: {
        
    },
    props: {
    },
};
</script>
<style scoped>
    .juniper-table tbody tr.selected {
        color: #000;
        font-weight: 700;
        background-color: rgba(0,0,0,.2);
    }
</style>
